import CurrencyList from './currencyList';

export default CurrencyList;
